module.exports = __webpack_public_path__ + "img/icono-falla.f5b0f624.svg";